<!--  -->
<template>
  <div class="loginBox" :style="{ width: isLoginModal && '432px' }">
    <img src="~@/assets/login/welcome.png" v-if="!isLoginModal" />
    <!-- 账号登录 -->
    <div class="loginInfo">
      <div class="change-scan-box" v-if="type == 'message' || type == 'account'">
        <span class="scan-tip" v-show="tipShow">微信扫码登录</span>
        <img src="~@/assets/login/gtn-code.png" class="gtn-code" @click="changeLogin(type)" />
      </div>
      <div class="change-scan-box" v-if="type == 'scan'">
        <span class="psd-tip" v-show="tipShow">密码登录</span>
        <img src="~@/assets/login/gtn-pc.png" class="gtn-code" @click="changeLogin(type)" />
      </div>
      <p class="weixin-scan login-title" v-if="type == 'scan'">微信扫码登录LIGHT云</p>
      <p :class="['login-title', flag ? 'login-title-judge' : '']" v-else>
        {{
          type === "account"
            ? "账号密码登录"
            : type === "message"
              ? "验证码登录"
              : "绑定手机号"
        }}
      </p>
      <div v-if="type !== 'scan'">
        <p class="login-tip" v-show="error_code == '110010'">
          用户名或密码错误，再错2次用户将被锁定15分钟，您可以切换
          <span @click="changeMethods(type)">手机验证码登录</span>或
          <router-link to="/forgetPassword" class="color-blue">忘记密码？</router-link>
        </p>
        <p class="login-tip" v-show="error_code !== '110010' && error_code !== ''">{{ tips }}</p>
      </div>
      <h-form
        ref="form"
        :model="formData"
        :rules="formRules"
        class="form11"
        inline
        style="position: relative"
      >
        <h-form-item prop="login_name" v-if="type == 'account'" key="1">
          <h-input
            class="login-input"
            type="text"
            v-model="formData.login_name"
            placeholder="手机号/邮箱"
            autocomplete="off"
          ></h-input>
        </h-form-item>
        <h-form-item prop="login_password" v-if="type == 'account'" key="2">
          <h-input
            v-show="!passwordSee"
            type="password"
            class="login-input"
            v-model="formData.login_password"
            placeholder="密码"
            autocomplete="new-password"
          ></h-input>
          <h-input
            v-show="passwordSee"
            class="login-input"
            v-model="formData.login_password"
            placeholder="密码"
            autocomplete="new-password"
          ></h-input>
          <img
            v-show="!passwordSee"
            class="see-open"
            @click="passwordSee = true"
            src="~@/assets/login/eyeOpen.png"
          />
          <img
            v-show="passwordSee"
            class="see-close"
            @click="passwordSee = false"
            src="~@/assets/login/eyeClose.png"
          />
        </h-form-item>

        <!-- 验证码登录与微信扫码登录复用 -->
        <h-form-item prop="phone" v-if="type == 'message' || type == 'weixin'" key="3">
          <div class="phone-div">+86</div>
          <h-input
            type="text"
            class="login-input phone-input"
            v-model="formData.phone"
            placeholder="请输入您的手机号"
            autocomplete="off"
          ></h-input>
        </h-form-item>
        <h-form-item prop="captcha_img_code" v-if="type !== 'scan' && imageCodeShow" key="5">
          <h-input
            class="login-input"
            type="text"
            v-model="formData.captcha_img_code"
            placeholder="请输入图形验证码"
          ></h-input>
          <img class="image-code" :src="imageCode.captcha_img_base64" @click="getCheckCode" />
        </h-form-item>
        <h-form-item prop="captcha_sms_code" v-if="type == 'message' || type == 'weixin'" key="4">
          <h-input
            type="text"
            class="login-input"
            v-model="formData.captcha_sms_code"
            placeholder="请输入短信验证码"
            autocomplete="off"
          ></h-input>
          <div
            @click="getSmsCheckCode(type)"
            class="message-div"
            :class="{
              'secondes-message':
                checkCodeActive && !resendShow && formData.phone
            }"
          >{{ !resendShow ? "获取短信验证码" : `${qrSeconds}秒后可重发` }}</div>
        </h-form-item>

        <!-- 账号密码登录与验证码登录复用 -->
        <h-form-item class="is-save" v-if="type == 'message' || type == 'account'">
          <h-checkbox v-model="loginNametSave" @on-change="clickEvent(type)">记住用户名</h-checkbox>
          <div>
            <a href="javascript:void(0);" @click="changeMethods(type)">
              {{
                type === "account" ? "手机验证码登录" : "账号密码登录"
              }}
            </a>
          </div>
        </h-form-item>
        <!-- 二维码 -->
        <img
          v-if="type == 'scan'"
          class="code-refresh"
          src="~@/assets/login/code-refresh.png"
          @click="getWechatQrCode"
        />
        <div v-if="type == 'scan'" id="login_container" class="weixin-code"></div>
        <h-form-item v-else>
          <h-button
            :class="['login-button', { 'go-login': loginBtnState }]"
            @click="login(type)"
            :disabled="loginBtnState == false"
          >登 录</h-button>
        </h-form-item>
      </h-form>
      <!-- <div class="phone-login">
        <a
          v-if="type == 'message' || type == 'account'"
          @click="changeMethods(type)"
        >
          {{ type === "account" ? "手机验证码登录" : "账号密码登录" }}
        </a>
      </div>-->
      <div
        class="is-regist"
        :class="{ 'forgetpsd-active': type == 'account' }"
        v-if="type == 'message' || type == 'account'"
      >
        <span>
          还没有账号？
          <router-link
            :to="registerRoute"
            class="color-blue"
            @click.native="
  regist(type);
gioTrackEvent('OP_registerSubmit');
            "
          >免费注册</router-link>
        </span>
        <router-link
          to="/forgetPassword"
          class="color-blue"
          v-if="type == 'account'"
          @click.native="handleTrack('PC_登录_账密_忘记密码')"
        >忘记密码？</router-link>
        <div v-if="type == 'message'" style="display: inline-block">
          <!-- <h-checkbox v-model="phoneSave">记住用户名</h-checkbox> -->
        </div>
        <!-- <a href="/forgetPassword" target="_blank">忘记密码？</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCode,
  accountLogin,
  smsCheckCode,
  smsLogin,
  wechatQrCode,
  wechatBindPhone
} from "@/api/login.js";
import { queryParams, getUrlParam } from "@/utils";
import trackMixin from "@/components/mixins/track.js";
export default {
  props: {
    isLoginModal: {
      type: Boolean,
      default: false
    },
    showBind: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //登录名验证
    const phoneOrEmailRule = (rule, value, callback) => {
      if (value) {
        if (
          !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value) &&
          !/^1[0-9]{10}$/.test(value)
        ) {
          this.checkCodeActive = false;
          // 不合法
          return callback(new Error("请输入正确的手机号码或邮箱"));
        }
      }
      this.checkCodeActive = true;
      return callback();
    };
    //验证短信验证码
    const checkCodeRule = (rule, value, callback) => {
      if (value) {
        if (value.length < 4) {
          return callback(new Error("最短不能少于4位字符"));
        }
      }
      return callback();
    };
    //手机号验证
    const phoneRule = (rule, value, callback) => {
      if (value) {
        if (!/^1[0-9]{10}$/.test(value)) {
          this.checkCodeActive = false;
          // 不合法
          return callback(new Error("请输入正确的手机号码"));
        }
      }
      this.checkCodeActive = true;
      return callback();
    };
    return {
      /**
       * type(登录方式): {
       *  account: 账号密码登录
       *  message: 验证码登录
       *  weixin: 微信登录
       *  scan: 微信扫码
       * }
       * loginNametSave：是否记住用户名
       * checkCodeActive: 手机验证是否合法
       * passwordSee: 是否显示密码
       * imageCode: 验证码对象
       * imageCodeShow: 是否显示图形验证码
       * tips: 错误提示
       * seconds： 60s倒计时
       * resendShow：是否显示xx秒后可重发
       * checkCodeActive： 手机号是否合法
       * passwordSee: 是否显示密码
       * weixinObj：微信对象
       * error_code：错误码
       */
      formData: {
        login_name: "",
        phone: "",
        captcha_sms_code: "",
        captcha_img_code: "",
        login_password: ""
      },
      flag: true,
      type: "account", //"message", //"account", //"weixin", //"scan",
      loginNametSave: false,
      formRules: {
        phone: [{ validator: phoneRule, trigger: "change" }],
        captcha_sms_code: [{ validator: checkCodeRule, trigger: "change" }],
        login_name: [{ validator: phoneOrEmailRule, trigger: "change" }]
      },
      imageCode: {},
      imageCodeShow: false,
      tips: "",
      seconds: 20,
      qrSeconds: 60,
      resendShow: false,
      tipShow: false,
      checkCodeActive: false,
      passwordSee: false,
      weixinObj: {},
      error_code: "",
      timer1: null,
      timer: null,
      registration_source: "" // 注册来源【从其他渠道带过来，如：高校答题】
    };
  },
  mixins: [trackMixin],
  computed: {
    // 表单不为空时登录按钮变蓝
    loginBtnState() {
      //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      // console.log(
      //   this.type,
      //   this.imageCodeShow,
      //   this.formData.phone,
      //   this.formData.captcha_sms_code,
      //   this.formData.login_password,
      //   this.formData.login_name
      // )
      if (this.type == "account") {
        if (
          !(
            this.formData.login_name &&
            this.formData.login_name !== "" &&
            this.formData.login_password &&
            this.formData.login_password !== ""
          ) ||
          (!(
            this.formData.captcha_img_code != "" &&
            this.formData.captcha_img_code
          ) &&
            this.imageCodeShow)
        )
          return false;
        else return true;
      } else {
        if (
          !(
            this.formData.phone &&
            this.formData.phone !== "" &&
            this.formData.captcha_sms_code &&
            this.formData.captcha_sms_code !== ""
          )
        )
          return false;
        else return true;
      }
    },
    // 跳转到注册的路由谢谢
    registerRoute() {
      const route = { path: "/register" };
      if (this.registration_source) {
        const url = decodeURIComponent(location.href).split("service=");
        route.query = { service: encodeURI(`${url[1]}service=${url[2]}`) }; // 将带到本页面的相关url带到注册页面，以便注册成功后能够回跳到来源页面
      }
      // url示例：http://localhost/openplat-front/register?service=https://hsuicuat.hundsun.cn/iuccasserver/login??service=https://xjl.dev.hs.net/login&registration_source=88
      return route;
    }
  },
  methods: {
    regist(type) {
      type == "account"
        ? this.handleTrack("PC_登录_账密_注册")
        : this.handleTrack("PC_验证码登录_注册");
    },
    clickEvent(type) {
      type == "account"
        ? this.handleTrack("PC_登录_账密_记住账号")
        : this.handleTrack("PC_验证码登录_记住账号");
    },
    //获取图形验证码
    getCheckCode() {
      CheckCode()
        .then(res => {
          this.imageCode = res;
          console.log(res, this.imageCode);
        })
        .catch(error => { });
    },
    getBackUrl() {
      let url = getUrlParam(window.location.href, "service");
      if (this.isLoginModal) {
        url = window.location.href.split("?wechat_auth_token")[0];
      } else {
        if (!url) {
          if (localStorage.getItem("backUrl")) {
            if (
              (localStorage.getItem("backUrl").indexOf("/login") !== -1 ||
                localStorage.getItem("backUrl").indexOf("/forgetPassword") !==
                -1 ||
                localStorage.getItem("backUrl").indexOf("/register") !== -1) &&
              localStorage.getItem("backUrl").startsWith(window.location.origin)
            )
              url = window.location.origin;
            else url = localStorage.getItem("backUrl");
          } else url = window.location.origin;
        }
      }
      return url;
    },
    // 登录埋点
    loginMd(token = "") {
      let hsid = this.$store.getters.hsid;
      gdp("setUserId", hsid);
    },
    //账号密码登录
    getAccountLogin() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const url = this.getBackUrl();
          var params = { ...this.formData, success_redirect: url };
          params = this.imageCodeShow
            ? { ...params, captcha_img_id: this.imageCode.captcha_img_id }
            : params;
          // console.log(params)
          accountLogin(params)
            .then(res => {
              this.error_code = res.error_code;
              // console.log(res, res.data["access_token"])
              if (res.error_code === "110004") {
                this.tips = res.error_info;
                this.imageCodeShow = true;
                this.getCheckCode();
              } else if (res.error_code === "0") {
                this.loginMd(res.data.access_token);

                this.tips = "";
                console.log(res.data["access_token"]);
                console.log(this.loginNametSave);
                // 如果用户点击记住用户名就保存账号
                this.loginNametSave
                  ? localStorage.setItem(
                    "form_loginName",
                    this.formData.login_name
                  )
                  : localStorage.removeItem("form_loginName");
                this.$store.commit("SET_TOKEN", res.data.access_token);
                // 根据路由参数，重定向地址
                // let u = this.$route.query.r_url
                // window.location.href = u ? window.location.origin+ decodeURIComponent(u) : res.data.success_redirect
                window.location.href = res.data.success_redirect;
              } else {
                this.getCheckCode();
                this.tips = res.error_info;
                console.log(this.tips);
              }
            })
            .catch(error => { });
        } else {
        }
      });
    },
    //获取短信验证码
    getSmsCheckCode(type) {
      console.log(type);
      type == "message"
        ? this.handleTrack("PC_验证码登录_获取验证码")
        : this.handleTrack("PC_绑定手机_获取验证码");
      if (!this.checkCodeActive || this.formData.phone === "") {
        // 手机号码不合法
        return;
      }
      if (this.resendShow) {
        // 获取短信验证码次数超显示图形验证码
        return;
      } else {
        console.log(type);
        var type = type == "message" ? 2 : 5;
        console.log(type);
        var params = { ...this.formData, captcha_sms_type: type };
        params = this.imageCodeShow
          ? {
            ...params,
            captcha_img_id: this.imageCode.captcha_img_id
          }
          : params;
        params = queryParams(params);
        smsCheckCode(params)
          .then(res => {
            this.error_code = res.error_code;
            if (res.error_code == "110004") {
              this.tips = res.error_info;
              this.imageCodeShow = true;
              this.getCheckCode();
            } else if (res.error_code == "0") {
              this.tips = "";
              clearInterval(this.timer);
              this.resendMessage();
            } else {
              this.getCheckCode();
              this.tips = res.error_info;
            }
          })
          .catch(error => { });
      }
    },
    //短信验证码登录
    getSmsLogin() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const url = this.getBackUrl();
          var params = { ...this.formData, success_redirect: url };
          smsLogin(params)
            .then(res => {
              this.error_code = res.error_code;
              if (res.error_code == "0") {
                this.tips = "";
                this.$store.commit("SET_TOKEN", res.data["access_token"]);
                this.loginMd(res.data["access_token"]);

                this.loginNametSave
                  ? localStorage.setItem("form_phone", this.formData.phone)
                  : localStorage.removeItem("form_phone");
                window.location.href = res.data.success_redirect;
              } else {
                this.getCheckCode();
                this.tips = res.error_info;
              }
            })
            .catch(error => { });
        } else {
        }
      });
    },
    // 60s后重新发送验证码
    resendMessage() {
      this.resendShow = true;
      this.timer = null;
      this.qrSeconds = 60;
      this.timer = setInterval(() => {
        if (this.qrSeconds == 0) {
          this.resendShow = false;
          clearInterval(this.timer);
          return;
        }
        this.qrSeconds--;
      }, 1000);
    },
    // 20s后提示消失
    controlTipBox() {
      this.tipShow = true;
      this.timer1 = null;
      this.seconds = 20;
      this.timer1 = setInterval(() => {
        if (this.seconds == 0) {
          this.tipShow = false;
          clearInterval(this.timer1);
          return;
        }
        this.seconds--;
      }, 1000);
    },
    //pc获取微信登录二维码js对象
    getWechatQrCode() {
      const url = this.getBackUrl();
      localStorage.setItem("backUrl", url);
      const { origin, pathname } = location;
      const bindUrl = origin + pathname;
      var params = {
        success_redirect: escape(url),
        bind_redirect: escape(bindUrl)
      };
      let _this = this;
      params = queryParams(params);
      wechatQrCode(params)
        .then(res => {
          _this.weixinObj = JSON.parse(res.js_obj_string);
          //更改微信内嵌iframe里面的样式(base64转换)
          var href =
            "data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cy5zdGF0dXNfYnJvd3NlciB7CiBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogYm9yZGVyOiBub25lOwogbWFyZ2luOiAwOwogd2lkdGg6IDIyMHB4OwogaGVpZ2h0OiAyMjBweDsKfQouaW1wb3dlckJveCAuc3RhdHVzewogZGlzcGxheTogbm9uZQp9";
          _this.weixinObj.href = href;
          var obj = new WxLogin(_this.weixinObj);
          console.log(window.location.href, obj);
        })
        .catch(error => { });
    },
    // 微信绑定手机号
    getWechatBindPhone() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let url = this.getBackUrl();
          if (this.isLoginModal) {
            url = url.split("wechat_auth_token=")[0];
          }
          var params = {
            ...this.formData,
            success_redirect: url,
            wechat_auth_token: this.$route.query.wechat_auth_token,
            registration_source:
              this.registration_source ||
              sessionStorage.getItem("registration_source") ||
              ""
          };
          wechatBindPhone(params)
            .then(res => {
              this.error_code = res.error_code;
              if (res.error_code == "0") {
                sessionStorage.setItem("registration_source", "");
                this.tips = "";
                this.$store.commit("SET_TOKEN", res.data.access_token);
                this.loginMd(res.data.access_token);
                window.location.href = res.data.success_redirect;
              } else {
                this.getCheckCode();
                this.tips = res.error_info;
              }
            })
            .catch(error => { });
        } else {
        }
      });
    },
    // 不同方式登录函数
    login(type) {
      if (type == "account") {
        this.getAccountLogin();
        this.handleTrack("PC_登录_账密_登录按钮");
      } else if (type == "message") {
        this.getSmsLogin();
        this.handleTrack("PC_验证码登录_登录按钮");
      } else {
        clearInterval(this.timer);
        this.getWechatBindPhone();
        this.handleTrack("PC_绑定手机_登录按钮");
      }
    },
    // 切换账号密码登录与验证码登录
    changeMethods(type) {
      // if (this.type === "account") this.handleTrack("PC_登录_账密_验证码登录");
      // else this.handleTrack("PC_验证码登录_账号密码登录");
      this.type = type === "account" ? "message" : "account";
      this.$refs.form.resetFields();
      if (localStorage.getItem("form_loginName") && this.type == "account") {
        this.formData.login_name = localStorage.getItem("form_loginName");
        this.loginNametSave = true;
        this.checkCodeActive = false;
      } else if (localStorage.getItem("form_phone") && this.type == "message") {
        this.formData.phone = localStorage.getItem("form_phone");
        this.loginNametSave = true;
        this.checkCodeActive = true;
      } else {
        this.loginNametSave = false;
        this.checkCodeActive = false;
      }
      // 重置提示与图形验证
      this.imageCodeShow = false;
      this.error_code = "";
      console.log(this.imageCodeShow, this.error_code);
    },
    // 切换账号密码登录与扫码登录
    changeLogin(type) {
      clearInterval(this.timer1);
      this.controlTipBox();
      // if (this.type === "account") this.handleTrack("PC_登录_账密_二维码");
      // else if (this.type === "message")
      //   this.handleTrack("PC_验证码登录_二维码");
      // else this.handleTrack("PC_微信登录_二维码");
      if (this.type === "account" || this.type === "message") {
        this.getWechatQrCode();
        localStorage.setItem("showBindModal", true);
      } else {
        localStorage.setItem("showBindModal", false);
      }
      this.type = type === "scan" ? "account" : "scan";
      this.$refs.form.resetFields();
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    if (this.$route.query.loginType) {
      this.type = this.$route.query.loginType;
    }
    clearInterval(this.timer);
    // console.log(window.location.href.indexOf("wechat_auth_token"))
    if (window.location.href.indexOf("wechat_auth_token") != -1)
      this.type = "weixin";
    if (this.isLoginModal) {
      this.type = this.showBind ? "weixin" : "account";
    }
    if (localStorage.getItem("form_loginName") && this.type == "account") {
      this.formData.login_name = localStorage.getItem("form_loginName");
      this.loginNametSave = true;
      this.checkCodeActive = false;
    } else if (localStorage.getItem("form_phone") && this.type == "message") {
      this.formData.phone = localStorage.getItem("form_phone");
      this.loginNametSave = true;
      this.checkCodeActive = true;
    } else {
      this.loginNametSave = false;
      this.checkCodeActive = false;
    }
    // if (localStorage.getItem("form_loginName")) {
    //   this.formData.login_name = localStorage.getItem("form_loginName")
    //   this.loginNametSave = true
    // } else if (localStorage.getItem("form_phone")) {
    //   this.formData.phone = localStorage.getItem("form_phone")
    //   this.loginNametSave = true
    // }
    // this.formData.login_name = localStorage.getItem("form_loginName")
    //   ? localStorage.getItem("form_loginName")
    //   : ""
    // this.formData.phone = localStorage.getItem("form_phone")
    //   ? localStorage.getItem("form_phone")
    //   : ""
    // console.log(233)
  },
  updated() { },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.controlTipBox();
    // 获取注册来源字段
    const url = decodeURIComponent(location.href).split("service=");
    const redirectUrl = url[url.length - 1]; // 登录后重定向的地址
    if (redirectUrl.indexOf("registration_source") > -1) {
      // 如果该地址中有registration_source，则取出
      this.registration_source = getUrlParam(
        redirectUrl,
        "registration_source"
      );
      sessionStorage.setItem("registration_source", this.registration_source);
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.loginBox {
  position: relative;
  width: 732px;
  height: 478px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background: #ffffff;
  justify-content: space-between;
  z-index: 1;
  .loginInfo {
    width: 320px;
    margin: 50px auto 0;
    .color-blue {
      color: #3060ff;
    }
    .login-title {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #333333;
      height: 28px;
      text-align: center;
    }
    .image-code {
      width: 104px;
      height: 46px;
      position: absolute;
      right: 0px;
      border: 1px solid #d9d9d9;
      border-radius: 0 6px 6px 0;
      cursor: pointer;
    }
    .weixin-scan {
      margin-top: 64px;
    }
    .code-refresh {
      display: none;
    }
    .form11:hover .code-refresh {
      display: block;
      cursor: pointer;
    }

    //切换二维码扫码界面
    .change-scan-box {
      position: absolute;
      right: 0px;
      top: 0px;
    }
    .change-scan-box:hover {
      .scan-tip,
      .psd-tip {
        display: block !important;
      }
      .scan-tip {
        width: 110px;
      }
      .psd-tip {
        width: 83px;
      }
    }
    .weixin-code {
      width: 220px;
      height: 220px;
      margin: 40px auto;
    }
    .code-refresh {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .login-title-judge {
      margin-bottom: 21px;
    }
    .login-tip {
      font-size: 14px;
      color: #ff595e;
      span {
        cursor: pointer;
        color: #3060ff;
      }
    }
    .gtn-code {
      position: absolute;
      top: 0;
      right: 0;
      width: 78px;
      height: 78px;
      cursor: pointer;
    }
    .scan-tip,
    .psd-tip {
      // display: none;
      width: 83px;
      height: 30px;
      background: #3060ff;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #feffff;
      line-height: 30px;
      text-align: center;
      border-radius: 4px;
      position: absolute;
      right: 62px;
      top: 16px;
      &:before {
        position: absolute;
        right: -12px;
        top: 10px;
        content: "";
        width: 0;
        height: 0;
        border: 6px solid;
        border-color: transparent transparent transparent #3060ff;
      }
    }
    .scan-tip {
      width: 110px;
    }
    .login-button {
      width: 320px;
      height: 46px;
      border-radius: 6px;
      background: #e6e6e6;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 18px;
    }
    .go-login {
      background: #3060ff;
    }
    .phone-login {
      display: flex;
      justify-content: center;
      a {
        font-size: 14px;
        color: #3060ff;
        text-align: center;
      }
    }
    .is-regist {
      width: 320px;
      position: absolute;
      bottom: 40px;
      display: flex;
      justify-content: center;
    }
    .forgetpsd-active {
      justify-content: space-between;
    }
    .phone-div {
      position: absolute;
      top: 0;
      left: 0;
      background: #f7f7f7;
      border-radius: 6px 0 0 6px;
      border: 1px solid #d9d9d9;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      z-index: 5;
      width: 74px;
      height: 46px;
      line-height: 40px;
      text-align: center;
    }
    .message-div {
      position: absolute;
      top: 0;
      right: 0;
      // background: #3060ff;
      background: #e2e2e2;
      border: 1px solid #e2e2e2;
      width: 130px;
      height: 46px;
      // border: 1px solid #3060ff;
      border-radius: 0 6px 6px 0;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      line-height: 44px;
      cursor: not-allowed;
      // cursor: pointer;
    }
    .secondes-message {
      background: #3060ff;
      border: 1px solid #3060ff;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.loginBox {
  .loginInfo {
    .see-open,
    .see-close {
      cursor: pointer;
      width: 20px;
      height: 12px;
      position: absolute;
      right: 10px;
      top: 17px;
      z-index: 5;
    }
    .h-form-item {
      margin-bottom: 16px;
      height: 46px;
      .h-form-item-content {
        width: 320px;
      }
    }
    .is-save {
      height: 20px;
      div {
        float: right;
        a {
          color: #3060ff;
          text-align: center;
        }
      }
    }
    .login-input {
      .h-input {
        width: 320px;
        height: 46px;
        padding: 4px 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #9b9b9b;
        border-radius: 6px;
      }
    }
    .phone-input {
      .h-input {
        padding-left: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/loginMethods.vue